export default function getConfig() {
  const env = process.env.REACT_APP_HOST_TYPE || 'development'
  const configs = {
    development: {
      baseApiUrl: 'http://localhost:3000/api',
      // TODO: Change to correct video url
      videoBannerUrl: '/videos/sample_banner.mp4'
    },
    staging: {
      baseApiUrl: 'https://prudential-mdrt-2021.projectwebby.com/api',
      videoBannerUrl: '/videos/sample_banner.mp4'
    },
    production: {
      baseApiUrl: 'https://www.registration.pruevent-asia.com/api',
      videoBannerUrl: '/videos/sample_banner.mp4'
    }
  }

  return configs[env]
}
